import { useState, useEffect, useCallback } from "react";
import { GET_MOCK_CREDIT } from "../../Utils/apis";

// Custom hook to fetch mock credits and allow manual refresh
const useMockCredits = () => {
  const [credits, setCredits] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchCredits = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await fetch(GET_MOCK_CREDIT, {
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include', // send cookies for auth
      });
      if (!res.ok) throw new Error('Failed to fetch credits');
      const data = await res.json();
      setCredits(data.data ?? 0);
    } catch (err) {
      setError(err.message);
      setCredits(0);
    } finally {
      setLoading(false);
    }
  }, []);

  // Fetch credits once on hook usage (e.g. on page load)
  useEffect(() => {
    fetchCredits();
  }, [fetchCredits]);

  return { credits, loading, error, fetchCredits };
};

export default useMockCredits;
